
  export default {
  name: "OverWhy",
  props: {
      id: {
          default: '',
          type: String,
      },
      region: {
          default: 'uk',
          type: String,
      }
  },
  data() {
      return {

      }
    },
    render() {
      const slot = this.$slots.default
      //  return slot.text.replace(/,/g, "")
      return slot
    },
  }
